export default __webpack_public_path__ + "static/media/RealEtext.2e720b66.png";